/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import {CdkScrollable} from '@angular/cdk/scrolling';
import {MatButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';

export enum DialogMode {
    ALL = 'ALL',
    SELECTED = 'SELECTED'
}

export enum DownloadMode {
    SINGLE_PDF = 'SINGLE_PDF',
    ZIP = 'ZIP'
}

@Component({
    selector: 'elohn-pdf-print-all-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './pdf-print-all-dialog.component.html',
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, MatTooltip]
})
export class PdfPrintAllDialogComponent {

    public data = inject<{
    mode: DialogMode;
}>(MAT_DIALOG_DATA);

    public dialogMode: DialogMode;
    public readonly DialogMode = DialogMode;
    public readonly DownloadMode = DownloadMode;

    constructor() {
        this.dialogMode = this.data.mode;
    }

    public static open(
        dialog: MatDialog,
        dialogMode: DialogMode
    ): MatDialogRef<PdfPrintAllDialogComponent, DownloadMode> {
        return dialog.open(PdfPrintAllDialogComponent, {data: {mode: dialogMode}});
    }
}
